/* eslint-disable quotes */
// The list is in inverted chronological order.
// First items are the latest.

module.exports = [
  {
    title: "Web Shorten URL",
    image: "https://storage.wsus.me/uploads/project/project-wsu.png",
    message: `ShortURL is a tool to shorten a long link and create a short URL easy. You can simply shorten your urls. if you want to update your urls`,
    link: "https://wsus.me/",
  },
  // {
  //   title: "RESTAURANT KITA",
  //   image: "https://storage.wsus.me/uploads/project/expertfe.png",
  //   message: `[Dicoding] Menjadi Front-End Web Developer Expert. Build with: Webpack, Workbox, PWA, IndexedDB, HTML, CSS and JS. Testing: Jasmine, Karma, Codecept, Puppeteer. Code Convention: AirBnb JavaScript Style Guide \n\n tags: Workbox PWA Webpack MFWDE Dicoding IndexedDB`,
  //   link: "https://triandi-ntx.github.io/submission-web-expert/",
  // },
  // {
  //   title: "Single Page Apps",
  //   image: "https://storage.wsus.me/uploads/project/bfawdr.png",
  //   message: `Membangun SPA + API, Context, dan Hooks`,
  //   link: "https://triandi-ntx.github.io/submission-fundamentalreact-2/",
  // },
  {
    title: "Bookself Apps Pemula",
    image: "https://storage.wsus.me/uploads/project/pemulafe.png",
    message: `Submission Aplikasi Pengelolaan Data Menggunakan DOM dan Web Storage`,
    link: "https://triandi.wsus.me/",
  },
  // {
  //   title: "My Notes Apps",
  //   image: "https://storage.wsus.me/uploads/project/dasarreact.png",
  //   message: `Membangun Aplikasi Catatan Menggunakan React`,
  //   link: "https://triandi-ntx.github.io/my-note-apps/",
  // },
  {
    title: "Bantu Siswa",
    image: "https://storage.wsus.me/uploads/project/dasarfe.png",
    message: `Submission: Tugas Akhir Membuat Website`,
    link: "https://triandi.wsus.me/",
  },
  
];
